<template>
  <div id="app">
    <div class="wrapper">
      <Header v-if="checkHeaderCondition()" />

      <router-view class="content-body" />

      <Footer v-if="checkFooterCondition()" />
    </div>
    <portal-target name="modal-portal"></portal-target>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

import Header from '@/components/Header'
import Footer from '@/components/Footer'
import API, { HOMEPAGE_URL } from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

export default {
  name: 'Home',
  onIdle() {
    const authFrom = _.get(this.$session.get('chili'), 'auth_from', '')
    if (authFrom === 'tmb') {
      this.$http
        .post(
          API.AUTHORIZATION.LOGOUT,
          {},
          {
            headers: {
              ...generateAuthorizationRequestHeader(),
            },
          },
        )
        .then(res => res.json())
        .then(
          response => {
            this.$session.destroy()

            return (window.location.href = HOMEPAGE_URL)
          },
          error => {
            this.$session.destroy()

            return (window.location.href = HOMEPAGE_URL)
          },
        )
    }
  },
  onActive() {},
  components: {
    Header,
    Footer,
  },
  methods: {
    checkHeaderCondition() {
      return (
        this.$route.path.indexOf('document') === -1 &&
        this.$route.name !== 'index' &&
        this.$route.name !== 'login' &&
        this.$route.name !== 'tvilogin' &&
        this.$route.name !== 'tmblogin' &&
        this.$route.name !== 'callbacktvi' &&
        this.$route.name !== 'authlanding' &&
        this.$route.name !== 'docinsurance' &&
        this.$route.name !== 'doc_quickquotation'
      )
    },
    checkFooterCondition() {
      return (
        this.$route.path.indexOf('document') === -1 &&
        this.$route.name !== 'index' &&
        this.$route.name !== 'tvilogin' &&
        this.$route.name !== 'tmblogin' &&
        this.$route.name !== 'callbacktvi' &&
        this.$route.name !== 'authlanding' &&
        this.$route.name !== 'docinsurance' &&
        this.$route.name !== 'doc_quickquotation'
      )
    },
  },
}
</script>

<style lang="scss">
@import './styles/app';
</style>
